const doc = [({"da":({"js":({"merfoto":({"order_deliveries":({"delivery_methods":({"pick_up":({"index":({"pick_up":"Afhentning"})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;